'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Timer = require('./Timer');

var _Timer2 = _interopRequireDefault(_Timer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TimerManager = (function () {
  function TimerManager() {
    _classCallCheck(this, TimerManager);

    this.timers = [];
    this._timersToDelete = [];

    this._last = 0;
  }

  _createClass(TimerManager, [{
    key: 'update',
    value: function update(delta) {
      var deltaMS = undefined;
      if (!delta && delta !== 0) {
        deltaMS = this._getDeltaMS();
        delta = deltaMS / 1000;
      } else {
        deltaMS = delta * 1000;
      }

      for (var i = 0; i < this.timers.length; i++) {
        var timer = this.timers[i];
        if (timer.active) {
          timer.update(delta, deltaMS);
          if (timer.isEnded && timer.expire) {
            timer.remove();
          }
        }
      }

      if (this._timersToDelete.length) {
        for (var i = 0; i < this._timersToDelete.length; i++) {
          this._remove(this._timersToDelete[i]);
        }
        this._timersToDelete.length = 0;
      }
    }
  }, {
    key: 'removeTimer',
    value: function removeTimer(timer) {
      this._timersToDelete.push(timer);
    }
  }, {
    key: 'addTimer',
    value: function addTimer(timer) {
      timer.manager = this;
      this.timers.push(timer);
    }
  }, {
    key: 'createTimer',
    value: function createTimer(time) {
      return new _Timer2.default(time, this);
    }
  }, {
    key: '_remove',
    value: function _remove(timer) {
      var index = this.timers.indexOf(timer);
      if (index > 0) this.timers.splice(index, 1);
    }
  }, {
    key: '_getDeltaMS',
    value: function _getDeltaMS() {
      if (this._last === 0) this._last = Date.now();
      var now = Date.now();
      var deltaMS = now - this._last;
      this._last = now;
      return deltaMS;
    }
  }]);

  return TimerManager;
})();

exports.default = TimerManager;


/*****************
 ** WEBPACK FOOTER
 ** ./src/TimerManager.js
 ** module id = 3
 ** module chunks = 0
 **/